import React from 'react';
import { Transition } from 'react-transition-group';
import cn from 'classnames';

import OpenBasketButton from './OpenBasketButton';

import s from './open-basket-button-transition.scss';


export function OpenBasketButtonTransition(props) {
    const {
        isHidden,
        onClick,
        priceValue,
        originalPrice,
        promocodeConditions,
        title,
        position,
    } = props;

    return (
        <Transition in={!isHidden} timeout={500}>
            {(tstate) => {
                const classes = cn({
                    [s['order__content__basket-button']]: true,
                    [s[tstate]]: true,
                });
                return (
                    <div className={classes}>
                        <OpenBasketButton
                            title={title}
                            onClick={onClick}
                            priceValue={priceValue}
                            originalPrice={originalPrice}
                            promocodeConditions={promocodeConditions}
                            position={position}
                        />
                    </div>
                );
            }}
        </Transition>
    );
}
